import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import BoostUpDetail from '../../components/lms/membership-store/boostup/boostupdetail';
import LmsLayout from '../../components/lms/layout/LmsLayout';
import Dashboard from './dashboard/Dashboarad';
import TakeClass from './take-class/TakeClass';
import Resources from './resources/Resources';
import StudentMgmt from './student/StudentMgmt';
import StudentDetail from './student/StudentDetail';
import ClassGroupMgmt from './class-group/ClassGroupMgmt';
import ChannelService from '../../api/ChannelService';
import CreateAssignment from './assignment-mgmt/CreateAssignment';
import AssignmentStatus from './assignment-mgmt/AssignmentStatus';
import CreateRecitation from './recitation-mgmt/CreateRecitation';
import RecitationStatus from './recitation-mgmt/RecitationStatus';
import VoucherManagement from './voucher-mgmt/VoucherManagement';
import MembershipStore from './membership-store/MembershipStore';
import DalantManagement from './dalant-mgmt/DalantManagement';

const RouteLms = () => {
  useEffect(() => {
    ChannelService.hideChannelButton();
    return () => {
      ChannelService.showChannelButton();
    };
  }, []);

  return (
    <Routes>
      {/* base "/lms/:classId" */}

      {/* 부스트업 상세페이지 */}
      <Route path="/boostup/detail/:boostupId" element={<BoostUpDetail />} />

      {/* LMS */}
      <Route element={<LmsLayout />}>
        {/* 대쉬보드 */}
        <Route index path="/dashboard" element={<Dashboard />} />

        {/* 수업하기 */}
        <Route path="/take-class" element={<TakeClass />} />

        {/* 과제 관리 > 과제 내주기 */}
        <Route path="/assignment/create" element={<CreateAssignment />} />

        {/* 과제 관리 > 과제 현황 */}
        <Route path="/assignment/status" element={<AssignmentStatus />} />

        {/* AI인증제 관리 > AI인증제 내주기 */}
        <Route path="/recitation/create" element={<CreateRecitation />} />

        {/* AI인증제 관리 > AI인증제 현황 */}
        <Route path="/recitation/status" element={<RecitationStatus />} />

        {/* 이용권 관리 */}
        <Route path="/voucher" element={<VoucherManagement />} />

        {/* 달란트 관리 */}
        <Route path="/dalant" element={<DalantManagement />} />

        {/* 멤버십 스토어 */}
        <Route path="/membership-store" element={<MembershipStore />} />

        {/* 자료실 */}
        <Route path="/resources" element={<Resources />} />

        {/* 학생 관리 */}
        <Route path="/student" element={<StudentMgmt />} />

        {/* 반 관리 */}
        <Route path="/class-group" element={<ClassGroupMgmt />} />

        {/* 학생 상세 */}
        <Route path="/student/:studentId" element={<StudentDetail />} />

        {/* 비정상 접근시 대쉬보드로 */}
        {/* <Route path="/*" element={<InvalidRouteRedirect />} /> */}
      </Route>
    </Routes>
  );
};

const InvalidRouteRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 대쉬보드로 replace 리다이렉트
    navigate('./dashboard', { replace: true });
  }, [navigate]);
  return <></>;
};

export default RouteLms;
